import React from 'react';
import { HotkeyEvent } from './hotkey-event';
import { SystemEvent } from './system-event';

export const HotkeyListener = () => {
    return (
        <>
            <HotkeyEvent />
            <SystemEvent />
        </>
    );
};
